/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiKeycloakGetEntityRolesGet$Json$Params {
  username?: string;
  Authorization?: string;
}

export function apiKeycloakGetEntityRolesGet$Json(http: HttpClient, rootUrl: string, params?: ApiKeycloakGetEntityRolesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
  const rb = new RequestBuilder(rootUrl, apiKeycloakGetEntityRolesGet$Json.PATH, 'get');
  if (params) {
    rb.query('username', params.username, {});
    rb.header('Authorization', params.Authorization, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<string>>;
    })
  );
}

apiKeycloakGetEntityRolesGet$Json.PATH = '/api/keycloak/GetEntityRoles';
